export default function WhatIsSection() {
  return (
    <section id="what-is" className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            What Is <span className="text-primary-500">Vigorbuy Spreadsheet</span>?
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            A comprehensive digital product catalog that organizes thousands of fashion and lifestyle items into searchable categories, making product discovery fast, organized, and efficient.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="space-y-5">
            <div className="flex gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 flex-shrink-0">
                <i className="ri-file-list-3-line text-lg"></i>
              </div>
              <div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-1">Product Discovery Made Easy</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  The Vigorbuy spreadsheet organizes products into clear categories — Shoes, Hoodies, Jackets, Bags, and more — so you can browse collections without endless scrolling through scattered listings.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100/70 text-accent-600 flex-shrink-0">
                <i className="ri-stack-line text-lg"></i>
              </div>
              <div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-1">Structured Category Organization</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  Every item is placed into logical categories and subcategories, making it effortless to compare similar products, spot trends, and identify the best value picks across the Vigorbuy spreadsheet ecosystem.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100/70 text-secondary-700 flex-shrink-0">
                <i className="ri-shield-check-line text-lg"></i>
              </div>
              <div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-1">Shopping Confidence & Safety</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  The Vigorbuy spreadsheet community shares QC photos, seller reviews, and safety tips, helping you shop with confidence and avoid scams while finding the best products available.
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20overhead%20flatlay%20of%20a%20laptop%20displaying%20organized%20product%20categories%20beside%20carefully%20arranged%20fashion%20items%20including%20folded%20garments%20a%20leather%20bag%20and%20sunglasses%20on%20a%20light%20cream%20textured%20desk%20surface%2C%20a%20notebook%20with%20handwritten%20shopping%20notes%20and%20a%20pen%20nearby%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography%20with%20warm%20sand%20and%20beige%20tones%2C%20clean%20elevated%20composition%20conveying%20organized%20shopping%20planning&width=800&height=600&seq=what-is-vigorbuy-02&orientation=landscape"
                alt="Organized Vigorbuy spreadsheet product discovery concept"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}